import { movies, type Movie } from "@/mocks/movies";

export function getMovieById(id: string): Movie | undefined {
  return movies.find((m) => m.id === id);
}

export function getRecommendations(movie: Movie, limit = 4): Movie[] {
  const sameGenre = movies.filter(
    (m) => m.id !== movie.id && m.genres.some((g) => movie.genres.includes(g))
  );
  const sameCategory = movies.filter(
    (m) => m.id !== movie.id && m.category === movie.category && !sameGenre.includes(m)
  );
  return [...sameGenre, ...sameCategory].slice(0, limit);
}

export interface MovieFilter {
  category?: string;
  sub?: string;
  region?: string;
  year?: string;
  type?: string;
  sort?: string;
  keyword?: string;
}

export function filterMovies(filter: MovieFilter): Movie[] {
  const { category, sub, region, year, type, sort, keyword } = filter;
  const kw = (keyword || "").trim().toLowerCase();

  let result = movies.filter((m) => {
    if (category && m.category !== category) return false;
    if (sub && m.subCategory !== sub) return false;
    if (region && region !== "全部" && m.region !== region) return false;
    if (year && year !== "全部" && String(m.year) !== year) return false;
    if (type && type !== "全部" && !m.genres.includes(type)) return false;
    if (kw) {
      const haystack = `${m.title} ${m.summary} ${m.genres.join(" ")} ${m.region} ${m.category}`.toLowerCase();
      if (!haystack.includes(kw)) return false;
    }
    return true;
  });

  if (sort === "hot") result = result.slice().sort((a, b) => b.hot - a.hot);
  else if (sort === "rating") result = result.slice().sort((a, b) => b.rating - a.rating);
  else result = result.slice().sort((a, b) => (a.updateDate < b.updateDate ? 1 : -1));

  return result;
}

export function getSortedCategories() {
  return movies.slice().sort((a, b) => (a.updateDate < b.updateDate ? 1 : -1));
}